import React from "react";
import { Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import arkChatLogo from "../assets/images/arkChatLogo.svg";
import playStore_icon from "../assets/images/playStore_icon.svg";
import appleAppstore_icon from "../assets/images/appleAppstore_icon.svg";

const MobileView = () => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      px={3}
      pt={0}
      pb={4}
      sx={{ background: "#fff", textAlign: "center" }}
    >
      {/* Logo */}
      <Box alignSelf="flex-start" mb={3}>
        <img src={arkChatLogo} alt="Arkchat" style={{ width: "180px" }} />
      </Box>

      {/* Hero image */}
      <Box mb={3} width="100%" maxWidth="320px">
        <img
          src="https://attachment.arkchat.com/assets/logo.svg"
          alt="Arkchat"
          style={{ width: "100%", height: "auto" }}
        />
      </Box>

      {/* Headline */}
      <Typography
        variant="h6"
        fontWeight={700}
        mb={1}
        sx={{ lineHeight: 1.3, color: "#1a1a2e" }}
      >
        {appContent?.KEY132}
      </Typography>

      {/* Subtext */}
      <Typography
        variant="body2"
        color="text.secondary"
        mb={3}
        sx={{ maxWidth: "300px" }}
      >
        {appContent?.KEY266}
      </Typography>

      {/* Store buttons */}
      <Box display="flex" flexDirection="column" alignItems="center" gap={1.5} mb={4}>
        <a href="https://apps.apple.com/in/app/arkchat/id1618932796">
          <img src={appleAppstore_icon} alt="Download on the App Store" style={{ cursor: "pointer", height: "44px" }} />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.arkchat">
          <img src={playStore_icon} alt="Get it on Google Play" style={{ cursor: "pointer", height: "44px" }} />
        </a>
      </Box>

      {/* Desktop fallback */}
      <Typography variant="caption" color="text.secondary">
        {appContent?.KEY267}{" "}
        <a
          href="https://platform.arkchat.com/"
          style={{ color: "#6c63ff", fontWeight: 600 }}
        >
          platform.arkchat.com
        </a>
      </Typography>
    </Box>
  );
};

export default MobileView;
